
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { SvoiIcon } from '@svoi-ui/components/icon'
import ArticlesCard from '~/components/Cards/ArticlesCards/ArticlesCard.vue'
import AppButtonLink from '~/components/UI/AppButtonLink.vue'
import type { NewsCardModel } from '~/model/News'

export default defineComponent({
  name: 'ArticlesSlider',
  components: { SvoiIcon, ArticlesCard, AppButtonLink },
  props: {
    title: {
      type: String,
      default: ''
    },
    cards: {
      type: Array as PropType<Array<NewsCardModel>>,
      required: true
    },
    buttonTitle: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: ''
    }
  },
  setup() {
    const swiperOptions = {
      slidesPerView: 3,
      spaceBetween: 24,
      navigation: {
        nextEl: '#button-slider-next',
        prevEl: '#button-slider-prev'
      },
      breakpoints: {
        '0': {
          slidesPerView: 'auto',
          spaceBetween: 16
        },
        '1280': {
          slidesPerView: 3,
          spaceBetween: 20
        },
        '1440': {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    }

    return {
      swiperOptions
    }
  }
})
